import { ApiService } from "../../utils/api-service";
import { IPerformanceIndicatorAM } from "./performance-indicator-models";
import { autoinject } from "aurelia-framework";

@autoinject
export class PerformanceIndicatorService {
    constructor(private http: ApiService) {
    }

    getPerformanceIndicators() : Promise<IPerformanceIndicatorAM[]> {
        return this.http.fetchJson('performance-indicators');
    }

}